<div class="select-wrapper">
  <mat-select
    [(ngModel)]="value"
    panelClass="panel-class"
    [ngClass]="{
      placeholder: isPlaceholder,
      clearable: clearable,
      'border-highlighted': !!value && highlightIfSet,
      disabled: disabled
    }"
    [placeholder]="placeholder"
    [disabled]="disabled"
    (selectionChange)="selectionChange.emit($event)"
    [panelClass]="panelClass || ''"
    [compareWith]="compareWith"
    >
    @if (!!placeholder && deselectable) {
      <mat-option [disabled]="placeholderDisabled" value="">{{
        placeholder
      }}</mat-option>
    }
    @if (viewValue) {
      @for (item of itemsList; track item) {
        <mat-option
          [value]="getOptionValue(item)"
          [disabled]="item.disabled || null"
          [class.d-none]="item.hidden"
          >
          {{ item[viewValue] }}
        </mat-option>
      }
    }
    @if (!viewValue) {
      @for (item of itemsList | keyvalue: formControlsService.pipeComparator; track item) {
        <mat-option
          [value]="valueForRequest ? item[valueForRequest] : item.key"
          >
          {{ item.value }}
        </mat-option>
      }
    }
  </mat-select>

  @if (showCloseIcon) {
    <span class="reset-btn" id="atqa-reset-btn" (click)="reset()">
      <i class="material-icons" [class.highlighted]="highlightIfSet">close</i>
    </span>
  }
</div>
